/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ConnectRepositoryGitProviderDataParser = 
/* #__PURE__ */ parsers.object([
    ['assignmentId', codecNumber, 'assignment_id'],
]);
export class ConnectRepositoryGitProviderData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ConnectRepositoryGitProviderDataParser.decode(input).map(res => new ConnectRepositoryGitProviderData(res));
    }
    static unsafeDecode(input) {
        return ConnectRepositoryGitProviderData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ConnectRepositoryGitProviderDataParser.encode(data);
    }
    static schema() {
        return ConnectRepositoryGitProviderDataParser.schema();
    }
}
